/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import { Link } from "react-router-dom";
import { useEffect, useRef } from "react";
import "./menu.css";
import styled from "styled-components";
import { scroller } from "react-scroll";
import ConnectButton from "../ConnectButton";
import ThemeSwitchButton from "../ThemeSwitchButton";
import { MediumSVG, TwitterSVG } from "../../utils/svgs";

const Hamburger = () => {
  const menuRef = useRef(null);

  useEffect(() => {
    document.addEventListener("mouseup", function (event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        let form = document.getElementById("check");
        if (form) form.checked = false;
      }
    });
  }, []);

  const menus = ["Home", "Mint NFT", "Inventory", "About", "View Whitepaper"];

  const socials = [
    {
      link: "https://twitter.com/TrueapexFi?t=u4x5Yjtexb4Fai8NBug5wg&s=09",
      icon: TwitterSVG,
    },
    {
      link: "https://medium.com/@trueapexfinance_55238",
      icon: MediumSVG,
    },
  ];
  return (
    <nav role="navigation" className="lg:hidden block">
      <div id="menuToggle" ref={menuRef}>
        {/* A fake / hidden checkbox is used as click reciever,
    so you can use the :checked selector on it. */}

        <input type="checkbox" id="check" />

        {/* Some spans to act as a hamburger.
    
    They are acting like a real hamburger,
    not that McDonalds stuff. */}

        <span></span>
        <span></span>
        <span></span>

        {/* Too bad the menu has to be inside of the button
    but hey, it's pure CSS magic. */}

        <Menu id="menu">
          <div className="ml-[50px] mt-[100px]">
            <Menus className="flex flex-col font-[900] w-full mt-[50px]">
              {menus.map((data, i) => {
                return i === 4 ? (
                  <a
                    key={i}
                    target="_blank"
                    href={`https://trueapexfinances-organization.gitbook.io/product-docs/`}
                    className={`text-3xl leading-[2.2] text-white`}
                    rel="noreferrer"
                  >
                    {data}
                  </a>
                ) : (
                  <Link
                    to={i === 3 ? "/home" : `/${data.replace(" ", "").toLowerCase()}`}
                    className="text-3xl leading-[2.2] text-white"
                    key={i}
                    onClick={() => {
                      let form = document.getElementById("check");
                      if (form) form.checked = false;
                      if (i === 3)
                        setTimeout(() => {
                          scroller.scrollTo("About", {
                            duration: 1000,
                            delay: 0,
                            smooth: true,
                          });
                        }, 10);
                    }}
                  >
                    {data}
                  </Link>
                );
              })}
            </Menus>
            <div className="mt-3">
              <ThemeSwitchButton />
            </div>
            <div className="w-full max-w-[240px] mt-8 ">
              <ConnectButton fullWidth={true} />
            </div>
            <div className="flex text-primary items-center mt-5">
              {socials.map((data, i) => {
                return (
                  <a
                    key={i}
                    target="_blank"
                    href={data.link}
                    rel="noreferrer"
                    className="mr-1 scale-[70%] hover:opacity-80 transition"
                  >
                    {data.icon}
                  </a>
                );
              })}
            </div>
          </div>
        </Menu>
      </div>
    </nav>
  );
};

const Menus = styled.div`
  > a {
    transition: all 0.3s !important;
    :hover {
      margin-left: 10px;
      color: #b6fdff !important;
    }
  }
  @media screen and (max-height: 960px) {
    margin: 0;
  }
`;

const Menu = styled.ul`
  position: relative;
  overflow: hidden;
`;

export default Hamburger;
